import styled from 'styled-components';
import { FlexCenterAligned, FlexibleDiv } from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';

export const ServicesSectionContainer = styled(FlexibleDiv)<{
  $itemCount: number;
}>`
  width: 100%;
  flex-wrap: wrap;
  gap: ${({ $itemCount }) => ($itemCount === 3 ? '5px' : '10px')};

  @media (min-width: ${Breakpoints.tablet}px) {
    gap: 10px;
  }
`;

export const ServicesSectionItem = styled(FlexCenterAligned)`
  height: 32px;
  padding: 8px;
  gap: 5px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 8px 10px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 6px 8px;
  }
`;
